import { useClientPortalAPI } from "@certn/api";

import { useOrderBillingProfile } from "./useOrderBillingProfile";

/**
 * DAT-1730: Returns whether the current order's billing profile is in the
 * "blocking" state (DAILY + CLIENT-pay + unpaid invoices + LD flag on) and,
 * if so, the matching `BlockingProfile` payload from the BillingNoticesView.
 *
 * Used by `ReviewStep` / `ReviewStepDailyPay` to disable Submit pre-emptively
 * so we don't bounce the user off a 402 they could have been warned about.
 * The backend 402 in `submit_order` is still the authoritative gate — this
 * is purely a UX nicety.
 */
export function useOrderBlockingProfile() {
  const { data: bp } = useOrderBillingProfile();
  const { data: notices } = useClientPortalAPI(
    "/api/internal/client-portal/customer-accounts/billing-notices/"
  );

  const blockingProfile = bp?.id
    ? notices?.blocking_profiles?.find((p) => p.billing_profile_id === bp.id) ??
      null
    : null;

  return {
    isBlocked: blockingProfile != null,
    blockingProfile,
  };
}
